/**
 * World Globe Level Gallery (Jonathan 2026-05-21).
 *
 * A gallery of player-created levels "other players have created and provided
 * to you". No backend — the list is a deterministic, simulated set generated
 * from seeds (matching the faked-multiplayer posture of the UGC layer). Each
 * level carries an author identity, a title, and a handful of simulated peer
 * reviews (resolved to localized snippets by the consuming scene) plus a
 * simulated Fun/Difficulty aggregate (via `RatingService`).
 */

import { hashString, makeSeededRng } from "./seededRng";
import { SIDEQUEST_NAME_POOL } from "./sidequestNamePool";

export interface GalleryLevel {
  id: string;
  title: string;
  authorSeed: number;
  /** Indices into the consuming scene's localized review-snippet pool. */
  reviewIndices: number[];
}

const LEVEL_COUNT = 12;

export class GalleryService {
  /**
   * Deterministic list of shared levels. `reviewPoolSize` is the size of the
   * caller's localized review-snippet pool so the picked indices stay in range.
   */
  static levels(reviewPoolSize: number): GalleryLevel[] {
    const out: GalleryLevel[] = [];
    for (let i = 0; i < LEVEL_COUNT; i++) {
      const rng = makeSeededRng(hashString(`gallery:${i}`));
      const title = SIDEQUEST_NAME_POOL[rng.intRange(0, SIDEQUEST_NAME_POOL.length)]!;
      const authorSeed = hashString(`gallery-author:${i}`);
      const count = rng.chance(0.5) ? 1 : 2;
      const reviewIndices: number[] = [];
      while (reviewIndices.length < count && reviewIndices.length < reviewPoolSize) {
        const idx = rng.intRange(0, reviewPoolSize);
        if (!reviewIndices.includes(idx)) reviewIndices.push(idx);
      }
      out.push({ id: `g${i}`, title, authorSeed, reviewIndices });
    }
    return out;
  }
}
